
import React from "react";
import { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import RegisterParticipant from "@/pages/RegisterParticipant";
import RegisterOrganizer from "@/pages/RegisterOrganizer";
import RegistrationSuccess from "@/pages/RegistrationSuccess";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { sendPageView } from "@/services/analyticsService";

const AuthRoutes = (): RouteObject[] => [
  {
    path: "/login",
    element: (
      <ProtectedRoute 
        requireAuth={false} 
        publicAccessible={true}
        onEnter={() => sendPageView("Bejelentkezés")}
      >
        <Login />
      </ProtectedRoute>
    )
  },
  {
    path: "/forgot-password",
    element: (
      <ProtectedRoute 
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Elfelejtett jelszó")}
      >
        <ForgotPassword />
      </ProtectedRoute>
    )
  },
  {
    path: "/reset-password",
    element: (
      <ProtectedRoute 
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Jelszó visszaállítás")}
      >
        <ResetPassword />
      </ProtectedRoute>
    )
  },
  {
    path: "/register/participant",
    element: (
      <ProtectedRoute 
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Résztvevői regisztráció")}
      >
        <RegisterParticipant />
      </ProtectedRoute>
    )
  },
  {
    path: "/register/organizer",
    element: (
      <ProtectedRoute 
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Szervezői regisztráció")}
      >
        <RegisterOrganizer />
      </ProtectedRoute>
    )
  },
  {
    path: "/registration-success",
    element: (
      <ProtectedRoute 
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Sikeres regisztráció")}
      >
        <RegistrationSuccess />
      </ProtectedRoute>
    )
  },
  {
    path: "/verify_email",
    element: (
      <ProtectedRoute 
        requireAuth={false}
        publicAccessible={true}
        onEnter={() => sendPageView("Email megerősítés")}
      >
        <VerifyEmail />
      </ProtectedRoute>
    )
  }
];

export default AuthRoutes;
